import { ProfileService } from 'src/app/_services/profiles.service';
import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { AuthenticationService } from '../_services/authentication.service';
import { Router } from '@angular/router';
import { User } from '../_models/user.model';
import { MsalService, BroadcastService } from "@azure/msal-angular";



@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  isCollapsed = true;
  userSubscription: Subscription;
  isUserAuthenticated = false;
  currentUser: User;
  showTramites: boolean;
  showConsultas: boolean;
  showMasivos: boolean;
  showReportes: boolean;
  showAdmin: boolean;

  constructor(
    private authService: AuthenticationService,
    private profilesService: ProfileService,
    private authB2c: MsalService,
    private router: Router
  ) {}

  ngOnInit() {
    this.showTramites = false;
    this.showConsultas = false;
    this.showMasivos = false;
    this.showReportes = false;
    this.showAdmin = false;
    this.userSubscription = this.authService.currentUser.subscribe(
      (user: User) => {
        if (user && user.authToken) {
          this.isUserAuthenticated = true;
          this.currentUser = user;
          this.showTramites = this.canShowOption('tramites', user);
          this.showConsultas = this.canShowOption('consultas', user);
          this.showMasivos = this.canShowOption('masivos', user);
          this.showReportes = this.canShowOption('reportes', user);
          this.showAdmin = this.canShowOption('admin', user);
        } else {
          this.isUserAuthenticated = false;
          this.currentUser = null;
        }
      }
    );
  }

  canShowOption(url: string, user: User): boolean {
    let res: boolean;
    let noCaps = '';
    if (url !== '' && url !== undefined && url !== null) {
      noCaps = url.toLowerCase();
      const currentUser:any = this.authService.currentUserValue;
      if (noCaps === 'tramites') {
        if (
          user.TipoDeUsuario === 'Empresa' ||
          user.TipoDeUsuario === 'Afiliado' ||
          user.TipoDeUsuario === 'Windows' ||
          user.TipoDeUsuario === 'No_Afiliado'
        ) {
          if (user.TipoDeUsuario === 'Windows'){
            if (user.windowsRoles.indexOf('Subsidio') > -1) {
              res = true;
            } else {
              res = false;
            }
          } else {
            res = true;
          }
        } else {
          res = false;
        }
      } else if (noCaps === 'consultas') {
        if (
          user.TipoDeUsuario === 'Empresa' ||
          user.TipoDeUsuario === 'Afiliado' ||
          user.TipoDeUsuario === 'Windows' ||
          user.TipoDeUsuario === 'No_Afiliado'
        ) {
          if (user.TipoDeUsuario === 'Windows') {
            if (user.windowsRoles.indexOf('Subsidio') > -1 || user.windowsRoles.indexOf('Consulta') > -1) {
              res = true;
            } else {
              res = false;
            }
          } else {
            res = true;
          }
        } else {
          res = false;
        }
      }else if (noCaps === 'masivos'){
        if (
          user.TipoDeUsuario === 'Empresa' ||
          user.TipoDeUsuario === 'Windows' 
        ) {
          res = true;
        }
        else {
          res = false;
        }
      }
      } else if (noCaps === 'reportes') {
        if (user.TipoDeUsuario === 'Windows') {
          if (user.windowsRoles.indexOf('Subsidio') > -1 || user.windowsRoles.indexOf('Admin') > -1) {
            res = true;
          } else {
            res = false;
          }
        } else {
          res = false;
        }
      } else if (noCaps === 'admin') {
        if (user.TipoDeUsuario === 'Windows') {
          if (user.windowsRoles.indexOf('Admin') > -1) {
            res = true;
          } else {
            res = false;
          }
        } else {
          res = false;
        }
      
    } else {
      res = false;
    }
    return res;
  }

  onSignout() {
    // Sign Out Code Here!

    localStorage.removeItem('currentUser');
    //this.authB2c.logout();
    this.profilesService.setSelectedProfile(-1);
    this.authService.currentUserSubject.next(null);
    //this.router.navigate(['logout']);
    this.authB2c.logout();
    //this.router.navigate(['/login']);


  }
}
